import * as React from 'react';
interface IReload {
    color: string; // ex: #f03742
}
const Reload: React.FC<IReload> = (props) => {
    const { color } = props;
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            style={{ margin: 'auto' }}
            width="20"
            height="20"
            display="block"
            preserveAspectRatio="xMidYMid"
            viewBox="0 0 100 100"
        >
            <g>
                <path
                    fill="none"
                    stroke={color}
                    strokeWidth="12"
                    d="M50 15a35 35 0 1024.749 10.251"
                ></path>
                <path fill={color} d="M49 3v24l12-12L49 3"></path>
                <animateTransform
                    attributeName="transform"
                    dur="1s"
                    keyTimes="0;1"
                    repeatCount="indefinite"
                    type="rotate"
                    values="0 50 50;360 50 50"
                ></animateTransform>
            </g>
        </svg>
    );
};

export default Reload;
